import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../../../components/Common/Button";
import StyledCalenderField from "../../../../../components/Classroom/StyledCalenderField";
import StyledTimeField from "../../../../../components/Classroom/StyledTimeField";
import moment from "moment";
import Loader from "../../../../../components/Loader";
import { calculateDuration } from "../../../../../utils/eventCalender";
import { rescheduleLiveClass } from "../../../../../utils/liveClasses";
import { toast } from "react-toastify";
import "./rescheduleSessionDialog.scss";

const RescheduleSessionDialog = ({
  isOpen,
  onClose,
  selectedSession = {},
  isMobileView = false,
  onUpdate = () => {},
  classroomEndDate = "",
}) => {
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(
    selectedSession?.start ? moment(selectedSession.start).format("YYYY-MM-DD") : ""
  );
  const [startTime, setStartTime] = useState(() => {
    const d = selectedSession?.start;
    if (!d) return "";
    const h = d.getHours().toString().padStart(2, "0");
    const m = d.getMinutes().toString().padStart(2, "0");
    return `${h}:${m}`;
  });
  const [endTime, setEndTime] = useState(() => {
    const d = selectedSession?.end;
    if (!d) return "";
    const h = d.getHours().toString().padStart(2, "0");
    const m = d.getMinutes().toString().padStart(2, "0");
    return `${h}:${m}`;
  });
  const [errors, setErrors] = useState({
    startDate: "",
    startTime: "",
    endTime: "",
  });

  const validateFields = () => {
    let isError = false;
    if (!startDate) {
      setErrors((prev) => ({ ...prev, startDate: "Start date is required" }));
      isError = true;
    }
    if (!startTime) {
      setErrors((prev) => ({ ...prev, startTime: "Start time is required" }));
      isError = true;
    }
    if (!endTime) {
      setErrors((prev) => ({
        ...prev,
        endTime: "End time is required",
      }));
      isError = true;
    }
    let isStartSame = false;
    let isEndSame = false;
    if (selectedSession?.start) {
      const SDate = moment(selectedSession?.start).format("YYYY-MM-DD");
      const STime = `${
        selectedSession?.start?.getHours().toString()?.length > 1
          ? selectedSession?.start?.getHours()
          : "0" + selectedSession?.start?.getHours()
      }:${
        selectedSession?.start?.getMinutes().toString()?.length > 1
          ? selectedSession?.start?.getMinutes().toString()
          : "0" + selectedSession?.start?.getMinutes().toString()
      }`;

      if (SDate === startDate && STime === startTime) {
        isStartSame = true;
      }
    }
    if (selectedSession?.end) {
      const ETime = `${
        selectedSession?.end?.getHours().toString()?.length > 1
          ? selectedSession?.end?.getHours()
          : "0" + selectedSession?.end?.getHours()
      }:${
        selectedSession?.end?.getMinutes().toString()?.length > 1
          ? selectedSession?.end?.getMinutes().toString()
          : "0" + selectedSession?.end?.getMinutes().toString()
      }`;

      if (ETime === endTime) {
        isEndSame = true;
      }
    }
    if (isEndSame === true && isStartSame === true) {
      toast.error("Please select different start and end time for reschedule.");
      isError = true;
    }
    return isError;
  };

  const handleSave = async (event) => {
    event.preventDefault();
    if (validateFields()) {
      return;
    }
    try {
      setLoading(true);
      const payload = {
        duration: calculateDuration(startTime, endTime),
        startDateTime: new Date(`${startDate} ${startTime}`).toISOString(),
      };
      const response = await rescheduleLiveClass(
        selectedSession?._id,
        JSON.stringify(payload)
      );
      if (response?.data?.liveclass) {
        toast.success(`Live class rescheduled successfully!`);
        await onUpdate();
        onClose();
        setLoading(false);
      } else {
        toast.error(
          response?.error?.message || `Unable to reschedule the live class.`
        );
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(`Unable to reschedule the live class.`);
      console.error("err", err);
    }
  };

  return (
    <Modal
      show={isOpen}
      className="ask-question-section-dialog"
      size="lg"
      onHide={onClose}
      centered
      dialogClassName="reschedule-session-modal"
      style={{ "--bs-modal-width": "600px" }}
    >
      {loading && <Loader />}
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title>Reschedule Session</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "30px" }}>
        <form>
          <div>
            <StyledCalenderField
              label="Start Date"
              value={startDate}
              onChange={(e) => {
                const txt = e?.target?.value;
                if (txt?.length === 0) {
                  setErrors({
                    ...errors,
                    startDate: "Start date is required.",
                  });
                } else {
                  setErrors({ ...errors, startDate: "" });
                }
                setStartDate(txt);
              }}
              marginBottom={24}
              errorMessage={errors?.startDate?.length && errors?.startDate}
              shouldSetMaxDate={!!classroomEndDate}
              maxDate={classroomEndDate ? moment(classroomEndDate).format("YYYY-MM-DD") : undefined}
            />
            <StyledTimeField
              label="Start Time"
              value={startTime}
              onChange={(e) => {
                const txt = e?.target?.value;
                if (txt?.length === 0) {
                  setErrors({
                    ...errors,
                    startTime: "Start Time is required.",
                  });
                } else {
                  setErrors({ ...errors, startTime: "" });
                }
                setStartTime(txt);
              }}
              errorMessage={errors?.startTime?.length && errors?.startTime}
              marginBottom={24}
            />
            <StyledTimeField
              label="End Time"
              value={endTime}
              onChange={(e) => {
                const txt = e?.target?.value;
                if (txt?.length === 0) {
                  setErrors({
                    ...errors,
                    endTime: "End Time is required.",
                  });
                } else {
                  setErrors({ ...errors, endTime: "" });
                }
                setEndTime(txt);
              }}
              errorMessage={errors?.endTime?.length && errors?.endTime}
              marginBottom={24}
            />
          </div>
          <div className="d-flex justify-content-start">
            <Button
              variant="primary"
              type="submit"
              className="px-4 m-0 save-btn"
              onClick={handleSave}
            >
              Reschedule
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default RescheduleSessionDialog;
